import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: #191919;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-right: 5px;\n  min-width: 200px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  min-width: 100%;\n\n  @media screen and (min-width: ", "px) {\n    justify-content: space-between;\n  }\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-top: 5px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    max-width: 250px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    max-width: 225px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { styled, PillNavigation } from '@acorns/web-components';
import { style } from '../../../../theme';
var StyledEnvToggle = styled(PillNavigation)(_templateObject(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));
var StyledEnvToggleContainer = styled.div(_templateObject2(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));
var StyledLabel = styled.label(_templateObject3());
var options = [{
  color: '#74C947',
  environment: 'staging',
  id: 0,
  text: 'Staging'
}, {
  color: '#ff6a00',
  environment: 'production',
  id: 1,
  text: 'Production'
}];

var EnvToggle = function EnvToggle(_ref) {
  var onToggle = _ref.onToggle,
      togglesEnv = _ref.togglesEnv;
  return /*#__PURE__*/React.createElement(StyledEnvToggleContainer, null, /*#__PURE__*/React.createElement(StyledLabel, null, "Select Feature Environment"), /*#__PURE__*/React.createElement(StyledEnvToggle, {
    labelColor: "",
    onSelect: function onSelect(index) {
      return onToggle(index);
    },
    options: options,
    selectedIndex: togglesEnv,
    selectedLabelColor: options[togglesEnv].color
  }));
};

export default EnvToggle;